import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "playButton"]

  connect() {
    this.videoTarget.addEventListener("play", () => this.hidePlayButton())
    this.videoTarget.addEventListener("pause", () => this.showPlayButton())
    this.videoTarget.addEventListener("ended", () => this.showPlayButton())
  }

  togglePlay(event) {
    event.preventDefault()
    if (this.videoTarget.paused) {
      this.videoTarget.play()
    } else {
      this.videoTarget.pause()
    }
  }

  hidePlayButton() {
    this.playButtonTarget.classList.add("hidden")
  }

  showPlayButton() {
    this.playButtonTarget.classList.remove("hidden")
  }
} 